/***
 * Params:
 * Data= [{
 * id: int
 * profiles: [int,int,int,int]
 * }]
 */

/***
 * return: 
 * result = 
     * { [ids],count}
     * 
 */
export const countPanelsWithProfile = (data) => {
  /***
   * Dado un array de cms con una lista de perfiles,guarda los ids y una cuenta de los cms que tengan al menos un perfil de la lista activado. 
   * En este caso 0 o -1 o null significa no activado
   */
  if (!data) return { ids: [], count: 0 };

  const ids = data
    .filter(element => element.profiles?.some(profile => profile !== 0 && profile !== -1 && profile != null))
    .map(element => element.id);


  return { ids, count: ids.length };
};